<template>
    <div class="class-1">
      <!-- Header -->
      <AppHeader />
  
      <!-- Edit Branch Form -->
      <div class="container mt-4">
        <div class="row">
          <div class="col-12">
            <h2>Edit Branch</h2>
            <form @submit.prevent="handleEditBranch">
              <!-- Name Input -->
              <div class="form-row">
                <div class="form-group col-md-12">
                  <label for="name">Branch Name</label>
                  <input type="text" class="form-control" id="name" v-model="form.name" placeholder="Enter Branch Name" required>
                </div>
              </div>
  
              <!-- Max Chairs Input -->
              <!-- <div class="form-row">
                <div class="form-group col-md-12">
                  <label for="maxChairs">Max Chairs</label>
                  <input type="number" class="form-control" id="maxChairs" v-model="form.maxChairs" placeholder="Enter Max Chairs" required>
                </div>
              </div> -->
  
              <!-- All Chairs Input -->
              <!-- <div class="form-row">
                <div class="form-group col-md-12">
                  <label for="allChairs">All Chairs</label>
                  <input type="number" class="form-control" id="allChairs" v-model="form.allChairs" placeholder="Enter All Chairs" required>
                </div>
              </div> -->
  
              <!-- ERP Customer Name Input -->
              <div class="form-row">
                <div class="form-group col-md-12">
                  <label for="ERP_CustomerName">ERP Customer Name</label>
                  <input type="text" class="form-control" id="ERP_CustomerName" v-model="form.ERP_CustomerName" placeholder="Enter ERP Customer Name">
                </div>
              </div>
  
              <!-- isPOS Checkbox -->
              <div class="form-row">
                <div class="form-group col-md-12">
                  <div class="form-check">
                    <input type="checkbox" class="form-check-input" id="isPOS" v-model="form.isPOS">
                    <label class="form-check-label" for="isPOS">Is POS</label>
                  </div>
                </div>
              </div>
  
              <!-- Suspended Status Input -->
              <div class="form-row">
                <div class="form-group col-md-12">
                  <label for="isSuspend">Status</label>
                  <select class="form-control" id="isSuspend" v-model="form.isSuspend" required>
                    <option value="0">Active</option>
                    <option value="1">Suspended</option>
                  </select>
                </div>
              </div>
  
              <!-- Buttons -->
              <div class="form-row">
                <div class="form-group col-12 d-flex justify-content-between">
                  <button type="button" class="btn btn-secondary" @click="cancelEdit">Cancel</button>
                  <button type="submit" class="btn btn-primary">Save Changes</button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
  
      <!-- Footer -->
    </div>
  </template>
  
  <script>
  export default {
    data() {
      return {
        form: {
          name: '',
          lat: '0', 
          lng: '0', 
          maxChairs: '',
          allChairs: '',
          ERP_CustomerName: '',
          isPOS: false, 
          isSuspend: 0, 
          printLang: 1, 
          id: null, 
        },
        currentDate: '',
        currentTime: '',
        branchId: null,
      };
    },
    mounted() {
      this.branchId = this.$route.params.id;
      console.log(this.branchId);
      this.updateDateTime();
      this.startDateTimeUpdate();
      this.fetchBranchDetails(); 
    },
    methods: {
      updateDateTime() {
        const now = new Date();
        this.currentDate = now.toLocaleDateString('en-GB', {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric',
        });
        this.currentTime = now.toLocaleTimeString('en-US', {
          hour: '2-digit',
          minute: '2-digit',
          hour12: true,
        });
      },
      startDateTimeUpdate() {
        setInterval(() => {
          this.updateDateTime();
        }, 1000);
      },
      async fetchBranchDetails() {
        try {
          this.$root.isLoading = true; 
          this.loading = true;
          const token = localStorage.getItem('authToken');
          const branchId = this.$route.params.id; 
  
          const response = await fetch(`${this.$BASE_API_URL}/api/branches/${branchId}`, {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${token}`,
            },
          });
  
          if (!response.ok) {
            throw new Error('Failed to fetch branch details');
          }
  
          const data = await response.json();
          this.form = {
            ...data.data, 
            name: data.data.name,
            isSuspend: parseInt(data.data.isSuspend), 
          };
        } catch (error) {
          console.error('Error fetching branch details:', error);
          this.$toast.error('Failed to load branch details. Please try again.');
        }
        finally {
      this.$root.isLoading = false;
      this.loading = false;
    }
      },
      async handleEditBranch() {
        try {
          this.$root.isLoading = true; 
          this.loading = true;
          const token = localStorage.getItem('authToken');
          const branchId = this.$route.params.id; 
          const payload = {
            appId: parseInt(localStorage.getItem('appId')), 
            name: this.form.name,
            lat: this.form.lat.toString(),
            lng: this.form.lng.toString(),
            allChairs: this.form.allChairs.toString(),
            maxChairs: this.form.maxChairs.toString(),
            printLang: this.form.printLang,
            id: parseInt(branchId),
            ERP_CustomerName: this.form.ERP_CustomerName,
            isPOS: this.form.isPOS,
            isSuspend: parseInt(this.form.isSuspend),
            created_at: new Date().toISOString(), // Update timestamp
            updated_at: new Date().toISOString(), // Update timestamp
          };
  
          const response = await fetch(`${this.$BASE_API_URL}/api/branches/${branchId}`, {
            method: 'PUT',
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify(payload),
          });
  
          const data = await response.json();
  
          if (response.ok) {
            this.$toast.success('Branch updated successfully!');
            this.$router.push('/branches'); 
          } else {
            this.$toast.error('Failed to update branch: ' + (data.message || 'Unknown error'));
          }
        } catch (error) {
          console.error('Error:', error);
          this.$toast.error('An error occurred. Please try again.');
        }
        finally {
      this.$root.isLoading = false;
      this.loading = false;
    }
      },
      cancelEdit() {
        this.$router.push('/branches'); 
      },
    },
  };
  </script>
  
  <style scoped>
  /* Add your custom styles here */
  .class-1 {
    font-family: 'Poppins', sans-serif;
  }
  
  .logo_icon {
    width: 100px;
    height: auto;
  }
  
  .container {
    max-width: 800px;
    margin: 0 auto;
  }
  
  .form-control {
    margin-bottom: 1rem;
  }
  
  .btn-primary {
    background-color: #4caf50;
    border: none;
    color: white;
    padding: 0.5rem 1rem;
    border-radius: 5px;
    cursor: pointer;
  }
  
  .btn-primary:hover {
    background-color: #45a049;
  }
  
  .btn-secondary {
    background-color: #6c757d;
    border: none;
    color: white;
    padding: 0.5rem 1rem;
    border-radius: 5px;
    cursor: pointer;
  }
  
  .btn-secondary:hover {
    background-color: #5a6268;
  }
  
  .txtfooter {
    margin-top: 2rem;
  }
  </style>